import { supabase } from '@/integrations/supabase/client'

interface SecurityEventData {
  event_type: string
  event_details?: Record<string, any>
  ip_address?: string
  user_agent?: string
}

export function useSecurityAudit() {
  const logSecurityEvent = async (eventData: SecurityEventData) => {
    try {
      const { error } = await supabase.rpc('log_security_event', {
        event_type: eventData.event_type,
        event_details: eventData.event_details || {},
        ip_address: eventData.ip_address,
        user_agent: eventData.user_agent || navigator.userAgent
      })
      
      // Silent fail in production - errors already logged server-side
      if (error && import.meta.env.DEV) {
        console.warn('Failed to log security event:', error)
      }
    } catch (err) {
      // Silent fail in production - security events are logged server-side
      if (import.meta.env.DEV) {
        console.warn('Security logging error:', err)
      }
    }
  }

  const logLoginAttempt = (success: boolean, email?: string) => {
    logSecurityEvent({
      event_type: success ? 'login_success' : 'login_failed',
      event_details: { email: email?.substring(0, 3) + '***' }
    })
  }

  const logDataAccess = (resource: string, action: string, count?: number) => {
    logSecurityEvent({
      event_type: 'data_access',
      event_details: { resource, action, count }
    })
  }

  const logSensitiveAction = (action: string, details?: Record<string, any>) => {
    logSecurityEvent({
      event_type: 'sensitive_action',
      event_details: { action, ...details }
    })
  }

  return {
    logSecurityEvent,
    logLoginAttempt,
    logDataAccess,
    logSensitiveAction
  }
}